/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hospital-patient-category-attributes.reducer';

export const HospitalPatientCategoryAttributesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospitalPatientCategoryAttributesEntity = useAppSelector(state => state.hospitalPatientCategoryAttributes.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospitalPatientCategoryAttributesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.detail.title">
            HospitalPatientCategoryAttributes
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.id}</dd>
          <dt>
            <span id="categoryCode">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.categoryCode">Category Code</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.categoryCode}</dd>
          <dt>
            <span id="multiplier">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.multiplier">Multiplier</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.multiplier}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.timestampEntry}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.endDate}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.addedByType}</dd>
          <dt>
            <span id="addedByID">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.addedByID">Added By ID</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.addedByID}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.modifiedByType}</dd>
          <dt>
            <span id="modifiedByID">
              <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.modifiedByID">Modified By ID</Translate>
            </span>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.modifiedByID}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.hospital">Hospital</Translate>
          </dt>
          <dd>{hospitalPatientCategoryAttributesEntity.hospital ? hospitalPatientCategoryAttributesEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospitalPatientCategoryAttributes.patientCategory">Patient Category</Translate>
          </dt>
          <dd>
            {hospitalPatientCategoryAttributesEntity.patientCategory ? hospitalPatientCategoryAttributesEntity.patientCategory.id : ''}
          </dd>
        </dl>
        <Button tag={Link} to="/hospital-patient-category-attributes" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/hospital-patient-category-attributes/${hospitalPatientCategoryAttributesEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospitalPatientCategoryAttributesDetail;
